import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const RodikliuPaaiskinimoDialogas = ({
  isExplainProblemDialogOpen,
  handleExplainProblemDialogClose,
}) => {
  return (
    // [x] create an explanation for the dialog
    <Dialog
      open={isExplainProblemDialogOpen}
      onClose={handleExplainProblemDialogClose}
      maxWidth="md"
      fullWidth
    >
      <Box>
        <DialogTitle>Karvės rodiklių problemų paaiškinimas</DialogTitle>
      </Box>
      <Box sx={{ marginLeft: 2 }}>
        <IconButton
          onClick={handleExplainProblemDialogClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black",
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent>
        <Typography>
          Lentelėje „<strong>Karvės istoriniai rodikliai</strong>“
          <span style={{ color: "red", fontWeight: "bold" }}> raudonai </span>pažymėti rodikliai,
          parodo, kad rodiklio reikšmė <strong>neatitinka</strong> normų:
        </Typography>
        <Typography>
          <List
            sx={{
              listStyleType: "disc",
              pl: 2,
              ml: 2,
              "& .MuiListItem-root": {
                display: "list-item",
              },
            }}
            dense
          >
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>R(%) </strong>riebalų procentas piene turėtų būti bent
                  <strong> 3,4%</strong>
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>B(%) </strong>baltymų procentas piene turėtų būti bent
                  <strong> 3% </strong>
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>P(kg) </strong>bazinis pieno primilžis turėtų būti bent
                  <strong> 10 kg</strong>
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>R/B (%) </strong>riebalų ir baltymų santykis turėtų būti tarp
                  <strong> 1% </strong>ir<strong> 1,4% </strong>
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>SLS (tūkst./ml) </strong>somatinių ląstelių skaičius neturėtų viršyti
                  <strong> 400(tūkst./ml)</strong>
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>L(%) </strong>laktozė turėtų būti bent<strong> 4%</strong>
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>U(mg%) </strong>Urėja turėtų būti tarp<strong> 15(mg%) </strong>ir
                  <strong> 30(mg%)</strong>
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>Sėkl. kartai </strong>sėklinimų kartų per laktaciją turėtų būti mažiau nei
                  <strong> 3</strong>
                </Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Typography>
        <Typography>
          Papildomai <span style={{ color: "red", fontWeight: "bold" }}>raudona</span> spalva yra
          pažymėtos būklės:
          <List
            sx={{
              listStyleType: "disc",
              pl: 2,
              ml: 2,
              "& .MuiListItem-root": {
                display: "list-item",
              },
            }}
            dense
          >
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>Nesėklinta </strong>- karvė nesėklinta
                  <strong> daugiau nei 110 d. </strong>
                  po apsiveršiavimo (servis periodas)
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>Veršinga </strong>- kuomet intervalas tarp paskutinių apsiveršiavimų yra
                  <strong> daugiau nei 400 d.</strong>
                </Typography>
              </ListItemText>
            </ListItem>
            <ListItem>
              <ListItemText>
                <Typography>
                  <strong>Užtrūkusi</strong>- kuomet karvė užtrūkusi
                  <strong> mažiau nei 30 d.</strong>
                </Typography>
              </ListItemText>
            </ListItem>
          </List>
        </Typography>
        <Typography>
          Būsena<strong> užtrūkusi </strong> yra pažymėta{" "}
          <span style={{ color: "#1F4E79", fontWeight: "bold" }}> mėlynai </span>, kuomet karvės
          užtrūkimas trunka<strong> daugiau nei 60d.</strong>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default RodikliuPaaiskinimoDialogas;
